import type { IDashboardFolder } from './dashboard-folder.types'
import { DashboardFolderView } from './dashboard-folder.view'

export const DashboardFolder = (props: IDashboardFolder) => {
  return <DashboardFolderView {...props} />
}
